import Raven from '../Raven';

export const getSamedayDelivery = () => {
    return Raven.get('https://6z251wlb2k.execute-api.us-east-2.amazonaws.com/dev/api/getsameday')
}